import * as dateFns from 'date-fns';
// TODO PSP-22135- Please rename this parameter
// and the one below with a prefix default and update all references
export const dateInputFormat: string = 'MM/dd/yyyy';
export const dateTextFormat: string = 'MMM d, yyyy';
export const defaultTimestampTextFormat: string = 'h:mm a';

// For use with date picker
// locale is currently ignored (it's included as a param to match the signature expected by the day picker)
// TODO (PSP-21153): This can be updated to use date-fns's parsing function after we upgrade to v2
export const parseDate = (
    // eslint-disable-next-line no-unused-vars
    date: Nullable<string>, format: string = dateInputFormat, locale?: string): Date | undefined => {
    if (!date) {
        return undefined;
    }

    return new Date(date);
};


export const formatDate = (
    // eslint-disable-next-line no-unused-vars
    date: NullOrUndefined<Date | string>, format: string = dateInputFormat, locale?: string): string  => {
    if (!date) {
        return '';
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }

    return dateFns.format(date, format);
};

export const formatTimestamp = (timestamp: string, format: string = defaultTimestampTextFormat): string => {
    if (!timestamp) {
        return '';
    }

    return dateFns.format(new Date(timestamp), format);
};

export const getDateLimitForCycle = (isMax: boolean, yearsToLimit: 10 | 100): Date => {
    const limit = yearsToLimit;

    const diff = isMax ? limit : -limit;
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() + diff);
    return currentDate;
};

export const dateValidForCycle = (dateToValidate: Date, yearsToLimit:  10 | 100): boolean => {
    return dateToValidate && dateToValidate <= getDateLimitForCycle(true, yearsToLimit) &&
        dateToValidate >= getDateLimitForCycle(false, yearsToLimit);
};